<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <right-nav></right-nav>
    <home-nav></home-nav>
    <home-banner
      :banners="banners"
      v-if="Object.keys(Object(banners)).length > 0"
    ></home-banner>
    <div>
      <div class="w">
        <div
          class="cates-item"
          v-for="item in category_products"
          :key="item.category_id"
        >
          <el-row class="cate-title">
            <el-col :span="12">
              <h2>{{ item.name }}</h2>
              <!-- <span>好货每天都有特价</span> -->
            </el-col>
            <el-col :span="12">
              <a style="cursor: pointer;" @click="goList(item)">更多 +</a>
              <!-- <router-link
                v-if="item.type != 'discount'"
                :to="{
                  name: 'products-list',
                  query: { type: item.type, category_id: item.category_id }
                }"
                >更多 +</router-link
              >
              <router-link
                v-else
                :to="{
                  name: 'products-list',
                  query: { type: item.type, Rate_id: discountStr }
                }"
                >更多 +</router-link
              > -->
            </el-col>
          </el-row>

          <el-row class="cate-body">
            <el-col :span="10">
              <div class="left-img">
                <img :src="item.bg_img_path" alt="sbz" />
                <div v-if="item.type != 'discount' && item.type != 'free'">
                  <span
                    v-for="(i, index) in item.categories"
                    :key="i.category_id"
                    v-show="index < 8"
                  >
                    <span @click="goCategory(item, i)">{{ i.name }}</span>
                  </span>
                  <div v-if="item.categories && item.categories.length > 8">
                    <span @click="goCategoryHome(item)">全部分类</span>
                  </div>
                </div>
                <div v-else>
                  <span v-for="i in item.categories" :key="i.value">
                    <router-link
                      :to="{
                        name: 'products-list',
                        query: {
                          type: item.type,
                          Rate_id: item.type === 'discount' ? i.value : 0
                        }
                      }"
                      >{{ i.label }}</router-link
                    >
                  </span>
                </div>
              </div>
            </el-col>
            <el-col :span="14">
              <el-row class="right-goods">
                <el-col
                  :span="8"
                  v-for="i in products(item.products)"
                  :key="i.product_id"
                  @click.native="goGoodsDetail(item, i.product_id)"
                >
                  <div v-if="i.dis_rate_text" class="dis_rate_text">
                    {{ i.dis_rate_text }}
                  </div>
                  <img :src="i.image ? i.image : defaultGoods" alt="goods" />
                  <p>{{ i.name }}</p>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import HomeBanner from "@/components/home-banner";
import DEFAULTGOODS from "@/assets/images/goods_default.jpg";

export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    HomeBanner
  },
  data() {
    return {
      category_products: [],
      banners: [],
      activityId: "",
      defaultGoods: DEFAULTGOODS,
      Rate_products: {},
      discountStr: ""
    };
  },
  mounted() {
    if (this.$util.getSessionStorage("activityId").activityId) {
      this.activityId = this.$util.getSessionStorage("activityId").activityId;
      this.getData();
    }
  },
  created() {
    this.$bus.off("choose-activity");
    this.$bus.on("choose-activity", this.getData);
  },
  methods: {
    getDiscount() {
      this.$reqGet("api/store/home/discount_agg_products").then(res => {
        if (res.data.success) {
          this.Rate_products = res.data.data;
          if (
            this.Rate_products.products &&
            this.Rate_products.products.length > 0
          ) {
            this.discountStr = "";
            this.Rate_products.agg.all_rates.map(item => {
              this.discountStr += item.value + ",";
            });
            this.discountStr = this.discountStr.substr(
              0,
              this.discountStr.length - 1
            );
            let Rate = {
              // bg_img_path:this.Rate_products.image,
              bg_img_path: this.Rate_products.image,
              categories: this.Rate_products.agg.all_rates,
              name: "品牌折扣",
              products: this.Rate_products.products,
              type: "discount",
              no_nav: true
            };
            this.category_products.unshift(Rate);
          }
        }
      });
    },
    getData() {
      this.$reqGet("api/ecomm/home/pc_home").then(res => {
        this.category_products = res.data.data.category_products;
        // 修改category_products 排序
        //是否在页面展示品牌折扣
        if (
          res.data.data.activity &&
          res.data.data.activity.products &&
          res.data.data.activity.products.home_page_display_discount
        ) {
          this.getDiscount();
        }
        let str = "";
        str = this.category_products.map(item => item.category_id).join(",");
        this.getCategoryProducts(str);
        this.banners = res.data.data.banners;
        if (res.data.data.activity.currency_name) {
          localStorage.setItem(
            "currency_name",
            res.data.data.activity.currency_name
          );
        }

        if (res.data.data.activity.rate) {
          localStorage.setItem("currency_rate", res.data.data.activity.rate);
        }
        this.getFreeShopping();
      });
    },
    getFreeShopping() {
      this.$reqGet("api/ecomm/product/free-shipping").then(res => {
        if (res.data.success) {
          let free = res.data.data;
          let data = {
            category_id: 0,
            name: "一件包邮",
            categories: free.agg.categories.splice(0, 8),
            products: free.products,
            bg_img_path: free.image,
            type: "free",
            no_nav: true
          };
          if (data.products.length > 5) {
            this.category_products.unshift(data);
            this.$forceUpdate();
          }
        }
      });
    },
    getCategoryProducts(str) {
      this.$reqGet("/api/ecomm/home/pc_home_product/" + str).then(res => {
        if (res.data.success) {
          for (let key in res.data.data) {
            // 修改首页供应商模块顺序 eg:原key是470 现key是 _470  key为数字时会按照大小排序
            this.category_products.map(item => {
              if (item.category_id == key) {
                item.products = res.data.data[key];
              }
            });
          }
          this.$forceUpdate();
        }
      });
    },
    goGoodsDetail(item, id) {
      if (!item.no_nav) {
        this.$bus.$emit("change-type", item);
      }
      let routeUrl = this.$router.resolve({
        path: "/productDetail",
        query: { type: item.type, product_id: id }
      });
      window.open(routeUrl.href, "_blank");
    },
    products(products) {
      if (products && products.length > 0) {
        return products.slice(0, 6);
      }
      return [];
    },
    goList(item) {
      let query = {};
      if (item.type === "discount") {
        query = { type: item.type, Rate_id: this.discountStr };
      } else if (item.type === "free") {
        query = { type: item.type, selected_postage: 1 };
      } else {
        query = { type: item.type, category_id: item.category_id };
      }
      if (!item.no_nav) {
        this.$bus.$emit("change-type", item);
      }
      this.$router.push({
        name: "products-list",
        query: query
      });
    },
    goCategory(item, i) {
      if (!item.no_nav) {
        this.$bus.$emit("change-type", item);
      }
      let routeUrl = this.$router.resolve({
        name: "products-list",
        query: { type: item.type, category_id: i.category_id }
      });
      window.open(routeUrl.href, "_blank");
    },
    goCategoryHome(item) {
      if (!item.no_nav) {
        this.$bus.$emit("change-type", item);
      }
      let routeUrl = this.$router.resolve({
        name: "category-home",
        query: { type: item.type, id: item.category_id }
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.cates-item {
  .cate-title {
    h2 {
      display: inline-block;
      font-size: 26px;
      color: #000;
      margin: 20px 10px 10px 0;
    }
    span {
      font-size: 18px;
      color: #999;
    }
    > div:last-child {
      text-align: right;
      padding-top: 35px;
    }
  }
  .cate-body {
    .left-img {
      width: 440px;
      height: 500px;
      position: relative;
      img {
        width: 100%;
      }
      > div {
        position: absolute;
        top: 172px;
        left: 120px;
        right: 70px;
        > span {
          display: inline-block;
          width: 49%;
          text-align: center;
          line-height: 36px;
          cursor: pointer;
          color: #fff;
          a {
            color: #fff;
          }
        }
        > div {
          text-align: center;
          span {
            display: inline-block;
            width: 120px;
            height: 32px;
            line-height: 32px;
            border: 1px solid rgba(255, 255, 255, 1);
            border-radius: 16px;
            padding: 0;
            margin-top: 10px;
            background: none;
            color: #fff;
            text-align: center;
            cursor: pointer;
          }
        }
      }
    }
    .right-goods {
      .el-col {
        padding: 10px;
        border: 0.6px solid #f6f6f6;
        text-align: center;
        background-color: #fff;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
        .dis_rate_text {
          width: 40px;
          text-align: center;
          position: absolute;
          top: 0;
          left: 0;
          padding: 5px 0;
          background: #e2333f;
          color: #fff;
          font-size: 12px;
        }
      }
      img {
        width: 160px;
        height: 160px;
        transition: margin-left 0.7s;
        &:hover {
          margin-left: -40px;
        }
      }
      p {
        text-align: left;
        padding: 0 10px;
        height: 40px;
        color: rgba(102, 102, 102, 1);
        line-height: 20px;
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue